import React from 'react';
import Auth from '../../lessonPlayer/services/AuthService';
import QuestionDependency from '../QuestionDependency';
import HtmlComponent from '../../lessonPlayer/components/HtmlComponent';

const MicrositeQuestion = ({ model, isManuscriptShort }) => {
  console.log('MicrositeQuestion model:', model);
  const micrositeUrl = model?.micrositeEntityId
    ? `${Auth.ecms}/api/redirectToMicrosite?resourceId=${model.micrositeEntityId}&authKey=${Auth.authKey}`
    : '';

  return (
    <div className='element-container' id={`_${model.id}`}>
      <div className='label-value-row'>
        <div>Question Type:</div>
        <div>Microsite Question</div>
      </div>
      <div className='label-value-row'>
        <div>Question Number:</div>
        <div>{model.questionNumber}</div>
      </div>
      <div className='label-value-row'>
        <div>Point Value:</div>
        <div>{model.maxScore}</div>
      </div>
      <div className='label-value-row'>
        <div className='text-area-label'>Question:</div>
        <div className='ckeditor-text text-area'><HtmlComponent htmlStr={model.questionText} /></div>
      </div>
      <div className='label-value-row'>
        <div>Microsite Entity ID:</div>
        <div>{model.micrositeEntityId}</div>
      </div>
      <div className='label-value-row'>
        <div>Microsite Name:</div>
        <div>{model.micrositeName}</div>
      </div>
      {micrositeUrl && (
        <div className='label-value-row'>
          <div>Microsite URL:</div>
          <div>{micrositeUrl}</div>
        </div>
      )}
      {micrositeUrl && (
        <iframe src={micrositeUrl} title={model.title || 'Microsite'} />
      )}
      {model.loadEventScript && (
        <div className='label-value-row'>
          <div>Load Event Script:</div>
          <div><pre>{model.loadEventScript}</pre></div>
        </div>
      )}
      {/* advanced options */}
      {!isManuscriptShort && (
        <>
          <QuestionDependency model={model} />
          <div className='label-value-row'>
            <div>Extra Class:</div>
            <div>{model.extraClass}</div>
          </div>
        </>
      )}
    </div>
  );
};
export default MicrositeQuestion;


